import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

interface IUseGetPostingPlansOptions {
  refetchOnWindowFocus?: boolean;
}

export const useGetPostingPlans = (options?: IUseGetPostingPlansOptions) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_POSTING_PLANS'],
    queryFn: async () => PermanentJobsService.getPostingPlans(),
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
